import { Component, Inject, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { isEqual } from 'lodash';
import { debounceTime, distinctUntilChanged, map, Observable } from 'rxjs';
import { Settings } from '../data/models';
import { APP_SETTINGS } from '../data/settings-data.provider';

@Component({
    selector: 'app-product-filter',
    template: `
    <div class="d-flex justify-content-between align-items-center my-1 pb-2">
      <div class="d-none d-lg-block fs-4 fw-bold pe-3" i18n>Produkte</div>
      <div class="w-100 mw-lg-640px">
        <div class="input-group w-100 focus-input-group">
          <div class="d-inline input-group-text bg-white border-end-0">
            <span class="material-icons">search</span>
          </div>
          <input
            type="text"
            [formControl]="searchControl"
            class="form-control bg-white border-start-0 border-end-0 shadow-none"
            placeholder="Suche nach Produktname, Artikelnummer oder Barcode"
            i18n-placeholder
          >
          <div class="d-inline input-group-text bg-white border-start-0">
            <button type="button" class="btn py-0" (click)="searchControl.reset()">
              <span class="material-icons">close</span>
            </button>
          </div>
        </div>
      </div>
    </div>

  `,
    styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
    standalone: false
})
export class ProductFilterComponent {
  @Output() filerChange: Observable<{ search: string } | null>;

  searchControl = new UntypedFormControl('');

  constructor(@Inject(APP_SETTINGS) public settings: Settings) {
    this.filerChange = this.searchControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(isEqual),
      map(value => !value ? null : { search: value })
    );
  }
}
